import { ReactNode } from 'react';
import { Trans } from '@lingui/macro';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import usePhoneNumber from 'hooks/usePhoneNumber';
import styles from './SummaryText.module.css';

type TProps = {
  children?: (phoneNumber: string, phoneNumberLink: string) => ReactNode;
};

export const SummaryText = ({ children }: TProps) => {
  const { introducerType } = useIntroducerContext();
  const isAccountant = introducerType === 'accountant';
  const { phoneNumber, phoneNumberLink } = usePhoneNumber(isAccountant);

  return (
    <p className={styles.text}>
      {children ? (
        children(phoneNumber, phoneNumberLink)
      ) : (
        <Trans>
          If you’d like to speak to us about this decision, give us a ring on{' '}
          <a href={`tel:${phoneNumberLink}`}>{phoneNumber}</a>.
        </Trans>
      )}
    </p>
  );
};
